export default __webpack_public_path__ + "assets/images/4797de785ecb532dc38799a97fcd9054.png";